<template>
  <p class="center italic text-dark marg-on-top" v-if="klassHasNoSubjects && theCalendar">{{ i18n[locale]['no_subjects_created'] }}
    <span
      class="text-link"
      @click="setImportSubjects">{{
        i18n[locale]['import_subjects']
      }}</span> {{ i18n[locale]['or_click_on_create_subject'] }}</p>
</template>

<script>
import eventbus from '../../eventbus'

export default {
  props: {
    calendarId: {},
    noSubjects: {
      default: false
    }
  },
  data () {
    return {
      klassHasNoSubjects: false,
      i18n: {
        da: {
          no_subjects_created: 'Ingen fag er oprettet. Du kan enten',
          import_subjects: 'importere standardfag',
          or_click_on_create_subject: 'eller klikke på "Opret brik"'
        },
        nb: {
          no_subjects_created: 'Det er ikke opprettet fag. Du kan enten',
          import_subjects: 'importere standardfag',
          or_click_on_create_subject: 'eller trykke på "Opprett fag"'
        }
      },
      en: {
        no_subjects_created: 'No courses have been created. You can choose to either',
        import_subjects: 'import courses',
        or_click_on_create_subject: 'or create them yourself by clicking on "Create course”'
      }
    }
  },
  computed: {
    locale () {
      return this.$store.getters.locale
    },
    allKlassCalendarsInHash () {
      return this.$store.getters.allKlassCalendarsInHash
    },
    theCalendar () {
      return this.allKlassCalendarsInHash[this.calendarId] ? this.allKlassCalendarsInHash[this.calendarId] : null
    }
  },
  methods: {
    setImportSubjects () {
      eventbus.theKlassesToImportSubjectTo = [this.theCalendar]
      eventbus.createKlassModal = true
    }
  },
  beforeMount () {
    this.klassHasNoSubjects = this.noSubjects
  },
  mounted () {
    window.addEventListener('vueUpdateSidebarSubjects', evt => {
      this.klassHasNoSubjects = false
    })
  },
  beforeDestroy () {
    window.removeEventListener('vueUpdateSidebarSubjects', evt => {
      this.klassHasNoSubjects = false
    })
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.text-link {
  color: var(--blue);
  cursor: pointer;
}

.marg-on-top {
  margin-top: 2rem;
}
</style>



// WEBPACK FOOTER //
// ImportSubjectsToKlass.vue?fd74a1ae